import { Stack, Typography } from "@mui/material";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import type { DataImportInfo } from "../../../../api/types/dataImportTypes";
import ImportDataStatusTag from "../ImportDataStatusTag";

interface Props {
  dataImportDetails: DataImportInfo;
}

const ImportDataDetailsTitle = ({ dataImportDetails }: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{ py: 1.5, alignItems: "center" }}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <Typography variant="h6">{dataImportDetails.description}</Typography>
        <Typography variant="h6">&bull;</Typography>
        <Typography variant="h6">{convertISODate(dataImportDetails.createdAt)}</Typography>
      </Stack>
      <ImportDataStatusTag dataImportState={dataImportDetails.state} />
    </Stack>
  );
};

export default ImportDataDetailsTitle;
